<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">复核算税</li>
      <li>
        您当前已选择：
        <strong style="color: #1e90ff; font-weight: 600">{{
          state.selectIds.length
        }}</strong>
        位员工
      </li>
      <el-button type="danger" link icon="Delete" @click="onClear()">
        清空已选择项
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click="onSubmits()"
        v-if="$judge_auth('572')"
      >
        批量复核算税
      </el-button>
      <el-button
        type="danger"
        link
        icon="Tickets"
        @click="onDeletes()"
        v-if="$judge_auth('571')"
      >
        批量删除
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        size="large"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.declare_exception_status"
        arrName="recalctaxemployee_status"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-date-picker
        v-model="state.params.tax_month"
        type="month"
        placeholder="所属税期"
        format="YYYY年M月"
        value-format="YYYY-MM"
      />
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-tree-select
        v-model="state.params.belonger_id"
        :props="{
          value: 'id',
          label: 'name',
          class: 'belonger-tree-class',
        }"
        placeholder="负责人"
        :data="state.admin_data"
        style="width: 200px"
        default-expand-all
        filterable
        clearable
      >
        <template #default="{ data }">
          <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
          <el-icon :size="16" v-else><User /></el-icon>
          <span style="margin-left: 3px">{{ data.name }}</span>
        </template>
      </el-tree-select>
      <el-input
        v-model="state.params.keywords"
        style="width: 300px"
        placeholder="姓名、手机号、证件号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="name"
          sortable="name"
          label="姓名"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          width="120"
          fixed="left"
        >
          <template #default="{ row }">
            <span>
              <text style="margin-right: 20px">{{ row.name }}</text>
              <el-tooltip :content="row.cwxx" placement="top">
                <el-icon color="#ffa500" style="cursor: pointer"
                  ><WarningFilled
                /></el-icon>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="140">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="手机号"
              @click="$onCopy(row.phone)"
            >
              {{ row.phone }}
            </text>
          </template>
        </el-table-column>
        <el-table-column prop="idcard" label="证件号" width="180">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.idcard)"
            >
              {{ row.idcard }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="状态/所属税期"
          prop="status"
          sortable="status"
          width="120"
        >
          <template #default="{ row }">
            <c_tabgroup :value2="row.tax_month">
              <template #top>
                <c_status
                  arrName="recalctaxemployee_status"
                  :value="row.declare_exception_status"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="申报结果" min-width="160">
          <template #default="{ row }">
            <c_tabgroup :value2="row.cwxx">
              <template #top>
                <text style="color: #f00">申报失败</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="算税单/工资表" min-width="160">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.calc_tax_order_id"
              :value2="row.payroll_order_id || '-'"
            />
          </template>
        </el-table-column>
        <el-table-column label="复核应税/历史应税工资" min-width="160">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.re_taxable_income"
              :value2="row.taxable_income"
            />
          </template>
        </el-table-column>
        <el-table-column label="复核税额/历史税额" min-width="160">
          <template #default="{ row }">
            <c_tabgroup :value1="row.re_tax_money" :value2="row.tax_money" />
          </template>
        </el-table-column>
        <el-table-column
          label="复核差额"
          min-width="160"
          prop="tax_money_diff"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          prop="skssq"
          label="员工税款所属期"
          :formatter="$tab_TextFormat"
          width="140"
        />
        <el-table-column
          prop="entry_time"
          label="入职日期"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="resignation_time"
          label="离职日期"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column label="客户/扣缴义务人" min-width="220">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.customer_name"
              :value2="row.withholding_agent_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="add_admin_name"
          label="负责人"
          :formatter="$tab_TextFormat"
          width="160"
        />
        <el-table-column
          label="操作"
          width="260"
          align="center"
          fixed="right"
          v-if="$judge_auth(['570', '571', '572'])"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Search"
              @click.stop="
                state.selectId = row.id;
                state.showDetail = true;
              "
              v-if="$judge_auth('570')"
            >
              详情
            </el-button>
            <el-button
              type="warning"
              link
              icon="Edit"
              @click.stop="onSubmit(row)"
              v-if="$judge_auth('572')"
            >
              复核算税
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click.stop="onDelete(row)"
              v-if="$judge_auth('571')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <el-dialog v-model="state.showDetail" title="详情" width="80%" align-center>
      <c_ReCalcTaxEmployeeDetail
        :id="state.selectId"
        :key="state.selectId"
      ></c_ReCalcTaxEmployeeDetail>
    </el-dialog>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { admin_cascader } from "@/utils/qFormat";
import {
  data_customer_select,
  data_withholdingagent_select,
} from "@/http/data";
import {
  recalctaxemployee_list,
  recalctaxemployee_del,
  recalctaxemployee_submit,
  recalctaxemployee_export,
} from "@/http/recalctaxemployee";
import { dayjs, ElMessageBox, ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const tableDom = ref(null);
    const state = reactive({ ...new InitFormData(), selectIds: [] });
    onMounted(() => {
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");

      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoadAdmin();
      onLoad();
    });

    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200) {
          state.withholding_agent_data = res.data.data?.list;
        }
      });
    };
    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载负责人
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      recalctaxemployee_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;

          setTimeout(() => {
            list.forEach((e) => {
              if (state.selectIds.includes(e.id)) {
                tableDom.value.toggleRowSelection(e);
              }
            });
          }, 500);
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
      if (state.selectIds.includes(row.id)) {
        state.selectIds = state.selectIds.filter((w) => w != row.id);
      } else {
        state.selectIds.push(row.id);
      }
    };

    const onSubmit = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#080'>复核</strong>员工<strong style='color:#1e90ff'>${row.name}</strong>的算税结果？`,
        "复核算税",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        recalctaxemployee_submit(row.id).then((res) => {
          if (res.status == 200)
            ElMessage({
              type: "success",
              grouping: true,
              message: res.data.msg,
            });
          onLoad();
        });
      });
    };

    const onSubmits = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定<strong style='color:#080'>复核</strong>已选<strong style='color:#1e90ff'>${rows.length}</strong>位员工的算税结果？`,
        "批量复核算税",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        recalctaxemployee_submit(rows.map((m) => m.id).join(",")).then(
          (res) => {
            if (res.status == 200)
              ElMessage({
                type: "success",
                grouping: true,
                message: res.data.msg,
              });
            onLoad();
          }
        );
      });
    };

    const onDelete = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#f00'>删除</strong>员工<strong style='color:#1e90ff'>${row.name}</strong>的算税结果？`,
        "删除",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        recalctaxemployee_del(row.id).then((res) => {
          if (res.status == 200)
            ElMessage({
              type: "success",
              grouping: true,
              message: res.data.msg,
            });
          onLoad();
        });
      });
    };

    const onDeletes = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定<strong style='color:#f00'>删除</strong>已选<strong style='color:#1e90ff'>${rows.length}</strong>位员工的算税结果？`,
        "批量删除",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        recalctaxemployee_del(rows.map((m) => m.id).join(",")).then((res) => {
          if (res.status == 200)
            ElMessage({
              type: "success",
              grouping: true,
              message: res.data.msg,
            });
          onLoad();
        });
      });
    };

    const onClear = () => {
      state.selectIds = [];
      tableDom.value.clearSelection();
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      recalctaxemployee_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onRowClick,
      onLoadAdmin,
      onSubmit,
      onSubmits,
      onDelete,
      onDeletes,
      onClear,
      onExport,
    };
  },
};
</script>
<style></style>
